export type DefinedPropsCoercer = (input: unknown, key: string) => unknown;
export function definedProps<T extends { [key: string]: unknown }>(
  obj: T,
  ignoredKeys?: string[],
  coerce?: DefinedPropsCoercer
) {
  const res: [keyof T, unknown | string | object][] = [];

  for (const key in obj) {
    let val: unknown = obj[key];
    if (val === undefined || val === null || val === '') {
      continue;
    }

    if (ignoredKeys?.includes(key)) {
      continue;
    }

    if (coerce) {
      val = coerce(val, key);
    }

    res.push([key, val]);
  }

  return res;
}
